<div class="file-preview-dialog">
  <button
    type="button"
    mat-icon-button
    class="file-preview-dialog__close"
    aria-label="Close document preview"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>

  <img class="file-preview-dialog__image" [src]="data.url" [alt]="data.name || 'Document preview'">
</div>
